module.exports = __webpack_public_path__ + "static/media/img3.b287a662.png";